module.exports = __webpack_public_path__ + "img/stop-btn.15ace06d.svg";